import { parseGenerationSeed } from './generationSeed.js';

const STORAGE_KEY = 'gachat:similarStandaloneImage';

const parseSizeSide = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const writeSimilarStandaloneImage = ({ prompt, style, loras, job_id, width, height, seed, negative } = {}) => {
  try {
    const jobId = Number(job_id);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      prompt: typeof prompt === 'string' ? prompt : '',
      style: style === 'realism' ? 'realism' : 'anime',
      loras: Array.isArray(loras) ? loras : [],
      job_id: Number.isFinite(jobId) && jobId > 0 ? jobId : null,
      width: parseSizeSide(width),
      height: parseSizeSide(height),
      seed: parseGenerationSeed(seed),
      negative: typeof negative === 'string' ? negative : '',
    }));
  } catch (error) {
    console.warn('writeSimilarStandaloneImage failed', error);
  }
};

export const consumeSimilarStandaloneImage = () => {
  let raw = null;
  try {
    raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const jobId = Number(parsed.job_id);
    return {
      prompt: typeof parsed.prompt === 'string' ? parsed.prompt : '',
      style: parsed.style === 'realism' ? 'realism' : 'anime',
      loras: Array.isArray(parsed.loras) ? parsed.loras : [],
      job_id: Number.isFinite(jobId) && jobId > 0 ? jobId : null,
      width: parseSizeSide(parsed.width),
      height: parseSizeSide(parsed.height),
      seed: parseGenerationSeed(parsed.seed),
      negative: typeof parsed.negative === 'string' ? parsed.negative : '',
    };
  } catch {
    return null;
  }
};
